import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import AdministratorEditor from './EditorPages/AdministratorEditor';
import AdministratorResults from './ResultsPages/AdministratorResults';

function Administrators({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <AdministratorEditor id={queryParams['id']} /> :
            <AdministratorResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Administrators);